export type SubtitleType =
  | "gift_cards"
  | "order_list"
  | "product_list"
  | "staff_members"
  | "extensions"
  | "extending_saleor"
  | "dev_panel"
  | "category_list"
  | "collection_list"
  | "customer_list"
  | "voucher_list"
  | "discount_list"
  | "channel_list"
  | "attribute_list"
  | "page_list"
  | "product_create"
  | "category_create"
  | "customer_create"
  | "collection_create"
  | "voucher_create"
  | "discount_create"
  | "channel_create"
  | "attribute_create"
  | "page_create";

const subtitles: Record<SubtitleType, string> = {
  gift_cards:        "Issue, track and manage gift cards for your customers",
  order_list:        "Track, fulfill and manage all customer orders",
  product_list:      "Manage your product catalog, pricing and inventory",
  staff_members:     "Control staff access with roles and permissions",
  extensions:        "Extend your store with apps, webhooks and integrations",
  extending_saleor:  "Connect external services using webhooks and events",
  dev_panel:         "Inspect GraphQL requests and responses in real time",
  category_list:     "Organise your catalog into a category hierarchy",
  collection_list:   "Group products into curated collections for your storefront",
  customer_list:     "View customer profiles, order history and contact details",
  voucher_list:      "Create and track discount voucher codes",
  discount_list:     "Configure automatic discounts and promotional rules",
  channel_list:      "Configure sales channels, currencies and regional settings",
  attribute_list:    "Define custom attributes used across products and variants",
  page_list:         "Manage content pages published on your storefront",
  product_create:    "Add a new product with variants, pricing and media",
  category_create:   "Add a new category to organise your product catalog",
  customer_create:   "Register a new customer with contact and address details",
  collection_create: "Curate a new collection of products for your storefront",
  voucher_create:    "Set up a new discount voucher code for your customers",
  discount_create:   "Configure a new automatic discount or promotional rule",
  channel_create:    "Set up a new sales channel with its own currency and region",
  attribute_create:  "Define a new attribute to enrich your product data",
  page_create:       "Create a new content page for your storefront",
};

export const useContextualLink = (type: SubtitleType): string => subtitles[type] ?? "";
